import script from "./VerificationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationPage.vue?vue&type=script&setup=true&lang=js"

import "./VerificationPage.vue?vue&type=style&index=0&id=50d13f3d&lang=css"

const __exports__ = script;

export default __exports__